export default "__VITE_ASSET__DS3Acm79__"